import { useSelector } from "react-redux";
import failedImg from "../../../assets/images/failed_tire.png";

/**
 * Terminal screen for an account that cannot use the site at all.
 *
 * Today this is only the missing-customer-number case: every CSFA endpoint
 * runs verify_user_customer() first, so there is nothing for the app to load
 * and nothing the user can do here except call us. It renders instead of the
 * routed tree — deliberately with no retry and no data fetches of its own.
 */
export default function AccountSetupPage() {
  const { fatalCustomerNumber, code } = useSelector(
    (state) => state.loadingTracker,
  );

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 via-white to-blue-100">
      <div className="m-6 w-full max-w-xl overflow-hidden rounded-2xl bg-white shadow-xl border border-blue-100">
        <div className="px-6 py-10 sm:p-8 text-center">
          <img
            className="max-h-28 mx-auto mb-6"
            alt="confused tire guy"
            src={failedImg}
          />

          <h1 className="font-serif text-3xl font-bold text-gray-800 mb-2">
            Your account isn't set up yet
          </h1>

          <p className="font-sans text-gray-600 mt-4 max-w-md mx-auto">
            This site needs a customer number attached to your login before it
            can show you products, pricing, or order history. Yours
            {fatalCustomerNumber
              ? ` (${fatalCustomerNumber}) isn't recognized.`
              : " is missing."}
          </p>

          <p className="font-sans text-gray-600 mt-4 max-w-md mx-auto">
            Please contact customer service and ask them to attach your customer
            number to your account. Refreshing the page won't fix it.
          </p>

          <p className="text-gray-400 mt-6 text-xs font-mono">{code}</p>
        </div>
      </div>
    </div>
  );
}
